//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { paramCase } from "param-case";
import latinize from "latinize";

export default {
  name: "RightDrawer",
  mounted: function () {
    this.loading = true;
    let rightDrawerCollapsers = this.$store.getters.getRightDrawerCollapsers;

    if (rightDrawerCollapsers === null) {

      let localCompletedCount = 0;
      BackendServices.getProductHierarchyLevels().then((response) => {
        this.collapsers[0].levels = response.data;

        this.$store.commit("initHierarchy", {
          hierarchy: "product",
          levelList: this.collapsers[0].levels,
        });

        this.collapsers[0].levels.forEach((level) => {
          BackendServices.getProductHierarchyLevelElements(level.id, null).then(
            (r) => {
              this.$store.commit("appendHierarchyLevelElements", {
                list: r.data,
              });
              this.$set(this.collapsers[0].elements, level.id, r.data);
              localCompletedCount++;
              if (localCompletedCount === this.collapsers[0].levels.length) {
                this.completedCount++;
              }
            }
          );
        });
      });

      BackendServices.getStoreHierarchyLevels().then((response) => {
        this.collapsers[1].levels = response.data;

        this.$store.commit("initHierarchy", {
          hierarchy: "store",
          levelList: this.collapsers[1].levels,
        });
        let localCompletedCount = 0;
        this.collapsers[1].levels.forEach((level) => {
          BackendServices.getStoreHierarchyLevelElements(level.id, null).then(
            (r) => {
              this.$store.commit("appendHierarchyLevelElements", {
                list: r.data,
              });
              this.$set(this.collapsers[1].elements, level.id, r.data);
              localCompletedCount++;
              if (localCompletedCount === this.collapsers[1].levels.length) {
                this.completedCount++;
              }
            }
          );
        });
      });

      BackendServices.getGeographyHierarchyLevels().then((response) => {
        this.collapsers[2].levels = this.hierarchySort(response.data);
        this.$store.commit("initHierarchy", {
          hierarchy: "geography",
          levelList: this.collapsers[2].levels,
        });

        this.collapsers[2].levels.sort(this.customSort);
        let localCompletedCount = 0;
        this.collapsers[2].levels.forEach((level) => {
          BackendServices.getGeographyHierarchyLevelElements(
            level.id,
            null
          ).then((r) => {
            this.$store.commit("appendHierarchyLevelElements", {
              list: r.data,
            });
            this.$set(this.collapsers[2].elements, level.id, r.data);
            localCompletedCount++;
            if (localCompletedCount === this.collapsers[2].levels.length) {
              this.completedCount++;
            }
          });
        });

      });

    } else {
      this.collapsers = rightDrawerCollapsers;
      this.loading = false;
    }

    this.getEmployeeList();
    this.getProductList();
    this.getStoreList();
    this.getNielsenList();
  },
  data: function () {
    return {
      loading: false,
      completedCount: 1,
      tab: null,
      productList: [],
      collapsers: [
        {
          hierarchyKey: "product",
          label: "Produto",
          levels: [],
          elements: {},
          extraFields: [
            {
              position: "after",
              type: "q-select",
              props: {
                label: "Produto (Nome/EAN)",
                square: true,
                outlined: true,
                class: "q-my-sm q-mx-xl",
                color: "blue-10",
                value: this.$store.getters.getProductList,
                multiple: true,
                "use-chips": true,
                options: [],
                "option-value": "id",
                "option-label": "name",
                "emit-value": true,
                "map-options": true,
                "use-input": true,
                "input-debounce": 500,
              },
              events: {
                add: (event) => {
                  this.$store.commit("addProductToProductList", event);
                },
                remove: (event) => {
                  this.$store.commit("removeProductFromProductList", event);
                },
                filter: (value, update) => {
                  update(() => {
                    this.getProductList(
                      this.$store.getters.getProductHierarchy,
                      value
                    );
                  });
                },
              },
            },
          ],
        },
        {
          hierarchyKey: "store",
          label: "Loja",
          levels: [],
          elements: {},
          extraFields: [
            {
              position: "after",
              type: "q-select",
              props: {
                label: "Loja (Nome/Código)",
                square: true,
                outlined: true,
                class: "q-my-sm q-mx-xl",
                color: "blue-10",
                value: this.$store.getters.getStoreList,
                multiple: true,
                "use-chips": true,
                options: [],
                "option-value": "id",
                "option-label": "name",
                "emit-value": true,
                "map-options": true,
                "use-input": true,
                "input-debounce": 500,
              },
              events: {
                add: (event) => {
                  this.$store.commit("addStoreToStoreList", event);
                },
                remove: (event) => {
                  this.$store.commit("removeStoreFromStoreList", event);
                },
                filter: (value, update) => {
                  update(() => {
                    this.getStoreList(
                      this.$store.getters.getStoreHierarchy,
                      value
                    );
                  });
                },
              },
            },
          ],
        },
        {
          hierarchyKey: "geography",
          label: "Geografia",
          levels: [],
          elements: {},
          extraFields: [
            {
              position: "before",
              type: "q-select",
              props: {
                label: "Àrea Nielsen",
                square: true,
                outlined: true,
                class: "q-my-sm q-mx-xl",
                color: "blue-10",
                value: this.$store.getters.getNielsenList,
                multiple: true,
                "use-chips": true,
                options: [],
                "option-value": "id",
                "option-label": "name",
                "emit-value": true,
                "map-options": true,
                "use-input": true,
              },
              events: {
                add: (event) => {
                  this.$store.commit("addNielsenToNielsenList", event);
                },
                remove: (event) => {
                  this.$store.commit("removeNielsenFromNielsenList", event);
                },
              },
            },
          ],
        },
        {
          hierarchyKey: "employee",
          label: "Vendedor",
          levels: [],
          elements: {},
          extraFields: [
            {
              position: "after",
              type: "q-select",
              props: {
                label: "Vendedor (Nome)",
                square: true,
                outlined: true,
                class: "q-my-sm q-mx-xl",
                color: "blue-10",
                value: this.$store.getters.getEmployeeList,
                multiple: true,
                "use-chips": true,
                options: [],
                "option-value": "id",
                "option-label": "name",
                "emit-value": true,
                "map-options": true,
                "use-input": true,
                "input-debounce": 500,
              },
              events: {
                add: (event) => {
                  this.$store.commit("addEmployeeToEmployeeList", event);
                },
                remove: (event) => {
                  this.$store.commit("removeEmployeeToEmployeeList", event);
                },
                filter: (value, update) => {
                  update(() => {
                    this.getEmployeeList(
                      value
                    );
                  });
                },
              },
            },
          ],
        },
      ],
      phantomStockButtons: [
        {
          label: "Todos",
          color: "blue-10",
          text: "white",
          onOff: true,
        },
        {
          label: "A",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "a",
        },
        {
          label: "B",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "b",
        },
        {
          label: "C",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "c",
        },
      ],
      cardexButtons: [
        {
          label: "Todos",
          color: "blue-10",
          text: "blue-4",
          onOff: true,
        },
        {
          label: "Activos",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "1",
        },
        {
          label: "Inactivos",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "0",
        },
      ],
      daysWithoutSales: [
        {
          label: "Todos",
          color: "blue-10",
          text: "blue-4",
          onOff: true,
        },
        {
          label: "3d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 3,
        },
        {
          label: "7d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 7,
        },
        {
          label: "15d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 15,
        },
        {
          label: "30d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 30,
        },
      ],
      daysCoverage: [
        {
          label: "Todos",
          color: "blue-10",
          text: "blue-4",
          onOff: true,
        },
        {
          label: "3d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 3,
        },
        {
          label: "7d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 7,
        },
        {
          label: "15d",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: 15,
        },
        {
          label: "Overstocking",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "max",
        },
      ],
      stockRupture: [
        {
          label: "Todos",
          color: "blue-10",
          text: "blue-4",
          onOff: true,
        },
        {
          label: "Stock menor 0",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "stocks",
        },
        {
          label: "Stock e vendas menor 0",
          color: "blue-4",
          text: "blue-10",
          onOff: false,
          value: "sales",
        },
      ],
    };
  },
  computed: {
    activeHierarchyList: function () {
      var vm = this;
      let firstReturn = function (collapseItem, hierarchyLevel, index) {
        let secondReturn = collapseItem.elements[hierarchyLevel.id] ? collapseItem.elements[hierarchyLevel.id].filter((i) => {
          if (!index) {
            return true;
          } else {
            return (vm.$store.getters.getHierarchyByKey(collapseItem.hierarchyKey, paramCase(latinize(collapseItem.levels[index - 1].name))).indexOf(i.parent_id) >= 0);
          }
        }) : [];
        return secondReturn;
      };
      return firstReturn
    },

  },
  methods: {
    latinize,
    paramCase,
    customSort(a, b) {
      if (a.parent_id === null) {
        return -1; // Move 'a' to the beginning
      }
      if (b.parent_id === null) {
        return 1; // Move 'b' to the beginning
      }
      return 0; // Leave the order unchanged
    },
    hierarchySort(array) {
      let sortedArray = [];
      let parentId = null;
      let nextItem = null;

      while (parentId !== undefined) {
        nextItem = array.find(item => item.parent_id === parentId);

        if (!nextItem) break;

        sortedArray.push(nextItem);

        parentId = nextItem.id;
      }

      return sortedArray;
    },
    addHierarchyLevel(levels, hierarchy, key, value) {
      this.$store.commit("addHierarchyLevel", {
        hierarchy: hierarchy,
        key: key,
        value: value.value,
      });

      //this.$store.commit("clearListByHierarchy", { hierarchy: hierarchy });

      switch (hierarchy) {
        case "product":
          this.getProductList(this.$store.getters.getProductHierarchy);
          break;
        case "store":
          this.getStoreList(this.$store.getters.getStoreHierarchy);
          break;
      }
    },
    removeHierarchyLevel(levels, hierarchy, key, value) {
      this.$store.commit("removeHierarchyLevel", {
        hierarchy: hierarchy,
        key: key,
        value: value.value,
      });

      let levelKeys = levels.map((i) => paramCase(latinize(i.name)));
      let index = levelKeys.indexOf(key);

      for (let i = index + 1; i < levelKeys.length; i++) {
        this.$store.commit("setHierarchyLevel", {
          hierarchy: hierarchy,
          key: levelKeys[i],
          value: [],
        });
      }

      this.$store.commit("clearListByHierarchy", { hierarchy: hierarchy });

      switch (hierarchy) {
        case "product":
          this.getProductList(this.$store.getters.getProductHierarchy);
          break;
        case "store":
          this.getStoreList(this.$store.getters.getStoreHierarchy);
          break;
      }
    },
    async getEmployeeList(search = null) {
      let response = null;
      let employeeData = null;
      response = await BackendServices.getRawEmployees();
      employeeData = response.data;

      if (search) {
        employeeData = employeeData.filter(e => e.name.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(search.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")))
      }

      this.collapsers[3].extraFields[0].props.options = Array.isArray(
        employeeData
      )
        ? employeeData
        : [];

    },
    async getProductList(hierarchy = null, search = null) {
      let response = null;
      let filters = null;
      let counter = 0;

      if (hierarchy) {
        filters = {};
        Object.keys(hierarchy).forEach((i) => {
          if (hierarchy[i].length > 0) {
            filters[counter] = { column_key: i, include: hierarchy[i] };
            counter++;
          }
        });
      }

      if (search) {
        filters[counter] = { column_key: "query", include: [search] };
      }

      response = await BackendServices.getProducts(
        { page: 1, rowsPerPage: 10 },
        filters,
        null,
        true
      );

      this.collapsers[0].extraFields[0].props.options = Array.isArray(
        response.data
      )
        ? response.data
        : [];
    },
    async getStoreList(hierarchy = null, search = null) {
      let response = null;
      let filters = null;
      let counter = 0;

      if (hierarchy) {
        filters = {};

        Object.keys(hierarchy).forEach((i) => {
          if (hierarchy[i].length > 0) {
            filters[counter] = { column_key: i, include: hierarchy[i] };
            counter++;
          }
        });
      }

      if (search) {
        filters[counter] = { column_key: "query", include: [search] };
      }

      response = await BackendServices.getStores(
        { page: 1, rowsPerPage: 10 },
        filters,
        true
      );

      this.collapsers[1].extraFields[0].props.options = Array.isArray(
        response.data
      )
        ? response.data
        : [];
    },
    async getNielsenList() {
      let response = null;

      response = await BackendServices.getNielsenAreas();

      this.collapsers[2].extraFields[0].props.options = Array.isArray(
        response.data
      )
        ? response.data
        : [];
    },
    filterStores: function (name, update) {
      update(async () => {
        await this.searchFilteredStores(name);
        this.storeList = this.storeList.filter(
          (item) => item.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    },
    setActive: function (button, index, buttonList) {
      if (index === 0) {
        button.onOff = true;
        button.color = "blue-10";
        button.text = "white";
        for (let i = 1; i < buttonList.length; i++) {
          buttonList[i].color = "blue-4";
          buttonList[i].text = "blue-10";
          buttonList[i].onOff = false;
        }
      } else {
        button.onOff = !button.onOff;
        button.color = button.onOff ? "blue-10" : "blue-4";
        button.text = button.onOff ? "white" : "button-10";
        buttonList[0].color = "blue-4";
        buttonList[0].text = "blue-10";
        buttonList[0].onOff = false;
      }
      this.updateStore();
    },
    updateStore: function () {
      let phantomStocksFilters = this.phantomStockButtons.map((i) => ({
        status: i.onOff,
        value: i.value,
      }));
      let cardexStatusFilters = this.cardexButtons.map((i) => ({
        status: i.onOff,
        value: i.value,
      }));
      let dwsaFilters = this.daysWithoutSales.map((i) => ({
        status: i.onOff,
        value: i.value,
      }));
      let coverageDaysFilters = this.daysCoverage.map((i) => ({
        status: i.onOff,
        value: i.value,
      }));
      let stockFilters = this.stockRupture.map((i) => ({
        status: i.onOff,
        value: i.value,
      }));
      if (phantomStocksFilters[0].status) {
        this.$store.commit("setValueOfCustomFilter", {
          key: "abc_class",
          value: null,
        });
      } else {
        this.$store.commit("setValueOfCustomFilter", {
          key: "abc_class",
          value: phantomStocksFilters
            .filter((i) => i.status)
            .map((i) => i.value),
        });
      }
      if (cardexStatusFilters[0].status) {
        this.$store.commit("setValueOfCustomFilter", {
          key: "cardex_status",
          value: null,
        });
      } else {
        this.$store.commit("setValueOfCustomFilter", {
          key: "cardex_status",
          value: cardexStatusFilters
            .filter((i) => i.status)
            .map((i) => i.value),
        });
      }
      if (dwsaFilters[0].status) {
        this.$store.commit("setValueOfCustomFilter", {
          key: "dwsa_aggreg",
          value: null,
        });
      } else {
        this.$store.commit("setValueOfCustomFilter", {
          key: "dwsa_aggreg",
          value: dwsaFilters.filter((i) => i.status).map((i) => i.value),
        });
      }
      if (coverageDaysFilters[0].status) {
        this.$store.commit("setValueOfCustomFilter", {
          key: "coverage_days",
          value: null,
        });
      } else {
        this.$store.commit("setValueOfCustomFilter", {
          key: "coverage_days",
          value: coverageDaysFilters
            .filter((i) => i.status)
            .map((i) => i.value),
        });
      }
      if (stockFilters[0].status) {
        this.$store.commit("setValueOfCustomFilter", {
          key: "stocks",
          value: null,
        });
      } else {
        this.$store.commit("setValueOfCustomFilter", {
          key: "stocks",
          value: stockFilters.filter((i) => i.status).map((i) => i.value),
        });
      }
    },
  },
  watch: {
    completedCount(newValue) {
      if (newValue === this.collapsers.length) {
        this.loading = false;
        this.$store.dispatch("setRightDrawerCollapsers", this.collapsers);
        this.completedCount = 0;
      }
    }
  }

};
